<script>
    import { HexagonSpinner } from "@axel669/zephyr"
</script>

<HexagonSpinner ws="@size: 80px;" />
<HexagonSpinner ws="@color: @success;" />
<HexagonSpinner ws="@size: 120px; @color: @accent;" />
<HexagonSpinner ws="@size: 140px; @color: @warning;" />
<HexagonSpinner ws="@size: 160px; @color: @error;" />
